import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { SelectInputComponent } from "../../../../../common/components";
import { InputLabel } from "@mui/material";
import OrderSelect from "./order-select";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

interface CreateInvoicePopupProps {
  isDialogOpen: boolean;
  setIsOpen: (open: boolean) => void;
  handleAddClick?: () => void;
  options?: any;
  setSelectedOrder?: (order: number | string | null) => void;
  setSelectedOrderTenantId?: (tenantId: number | null) => void;
}

const CreateInvoicePopup: React.FC<CreateInvoicePopupProps> = ({
  isDialogOpen,
  setIsOpen,
  handleAddClick,
  options,
  setSelectedOrder,
  setSelectedOrderTenantId,
}) => {
  const [errorMsg, setErrorMsg] = useState<Record<string, string>>({});
  const [selectedOrder, setOrder] = useState<number | string | null>(null);
  const [tenantId, setTenantId] = useState<number | null>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // true if screen ≤ 600px

  const handleCancel = () => {
    setIsOpen(false);
    setOrder(null);
    setTenantId(null);
    setErrorMsg({});
  };

  const handleCreateInvoice = () => {
    if (!selectedOrder) {
      setErrorMsg({ orderStatus: "Please select an order status" });
      return;
    }
    handleAddClick && handleAddClick();
    setSelectedOrder && setSelectedOrder(selectedOrder);
    setSelectedOrderTenantId && setSelectedOrderTenantId(tenantId || null);
    setOrder(null);
    setTenantId(null);
    setIsOpen(false);
  };

  const disableSubmit = !selectedOrder;

  return (
    <Dialog
      open={isDialogOpen}
      onClose={handleCancel}
      aria-labelledby="create-invoice-title"
      className="update-popup-wrapper"
      slotProps={{
          paper: {
            sx: {
              width: isMobile ? "90%" : "570px", // 90% width on mobile
              maxWidth: "95vw",                  // prevent overflow
              minHeight: isMobile ? "auto" : "280px",
              borderBottomLeftRadius: '30px',
            borderBottomRightRadius: '30px',
              top: 0,  // add spacing from top on mobile
              margin: 0,
              position: "absolute",
            },
          },
        }}
    >
      <DialogTitle
        id="create-invoice-title"
        style={{ borderBottom: "1px solid #ddd" }}
      >
        Select Order
      </DialogTitle>
      <DialogContent style={{ padding: "20px 24px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <InputLabel>Select Order</InputLabel>
          <div style={{ flex: 1 }}>
            <OrderSelect
              value={selectedOrder}
              onChange={(order) => {
                if (order) {
                  const { id, tenantId } = order;
                  setOrder(id);
                  setTenantId(tenantId);
                  setErrorMsg({});
                }
              }}
              options={options || []}
              disabled={false}
              touched={!!selectedOrder}
              error={!!selectedOrder}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions
        className="button-wrapper"
        style={{ padding: "16px 24px" }}
      >
        <Button onClick={handleCancel} className="cancel-btn">
          Cancel
        </Button>
        <Button
          disabled={disableSubmit}
          onClick={handleCreateInvoice}
          autoFocus
          className="update-btn"
          style={{ width: "131px", letterSpacing: "-0.02em" }}
        >
          Create Invoice
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateInvoicePopup;
